import { render, staticRenderFns } from "./DownloadAppSnackBanner.vue?vue&type=template&id=3412cb42&scoped=true&"
import script from "./DownloadAppSnackBanner.vue?vue&type=script&lang=ts&"
export * from "./DownloadAppSnackBanner.vue?vue&type=script&lang=ts&"
import style0 from "./DownloadAppSnackBanner.vue?vue&type=style&index=0&id=3412cb42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3412cb42",
  null
  
)

export default component.exports